"use client";

import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";
import Carousel from "@/components/shared/Carousel";

function Testimonial({
  title,
  body,
  author,
  memberState,
  memberSince,
}: {
  title: string;
  body: string;
  author: string;
  memberState: string;
  memberSince: string;
}) {
  const [isShowingAll, setIsShowingAll] = useState(false);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        color: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <StarIcon sx={{ color: "gold", fontSize: 20 }} />
        <StarIcon sx={{ color: "gold", fontSize: 20 }} />
        <StarIcon sx={{ color: "gold", fontSize: 20 }} />
        <StarIcon sx={{ color: "gold", fontSize: 20 }} />
        <StarIcon sx={{ color: "gold", fontSize: 20 }} />
      </Box>
      <Typography
        variant="h6"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          height: "64px",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={
            isShowingAll
              ? {}
              : {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "3",
                  WebkitBoxOrient: "vertical",
                }
          }
        >
          {body}
        </Typography>
        {!isShowingAll && (
          <Typography
            variant="body2"
            sx={{
              textAlign: "right",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => setIsShowingAll(true)}
          >
            Read more...
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // gap: 1,
        }}
      >
        <Typography>
          {author}, {memberState}
        </Typography>
        <Typography variant="caption">member since {memberSince}</Typography>
      </Box>
    </Box>
  );
}

export default function SellTestimonialsCarousel() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        padding: 8,
        paddingLeft: 16,
        paddingRight: 16,
        color: "white",
        backgroundColor: "black",
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        sx={{ textAlign: "center", color: "white" }}
      >
        What do other sellers think?
      </Typography>
      <Carousel
        slideWidth={300}
        slides={[
          <Testimonial
            key={1}
            title="No time wasters and easy to use!"
            body="I would recommend using Horsezone to anyone who is trying to sell a horse. I had a number of people enquire and none of the ones who enquired from Horsezone were time wasters. My listing came up looking fantastic and it was easy to create using the Horsezone template. I was very impressed with the service I got from Horsezone and would recommend it over any of the other more expensive websites and magazines I advertised in"
            author="Aliesha Moroney"
            memberState="NZ"
            memberSince="2013"
          />,
          <Testimonial
            key={2}
            title="VERY happy with the service at Horsezone"
            body="Thank you Horsezone, we have sold our stallion DMB The Innovator to a lovely home in Victoria. We were very happy with the response, from VERY reasonably priced advertising! We will definitely use horsezone again"
            author="Mandy Smith"
            memberState="QLD"
            memberSince="2020"
          />,
          <Testimonial
            key={3}
            title="Better than Horse Magazines"
            body="I have used a lot of different web sites and advertised in Horse Magazines and Newspapers and have found the best result has been Horsezone.  So far I have sold my ASH Gelding and a Saddle with another ASH mare still currently on the site which I'm getting a good response and that has only been in the last three months.  Horsezone is extremely affordable and I love the fact that I can up date my advert when ever I like with new photo's etc at anytime of the day or night.  I now tell everyone who is looking to buy or sell to use Horsezone as it has worked brilliantly for me. Keep up the good work.  Cheers"
            author="Tania Alderton"
            memberState="NSW"
            memberSince="2010"
          />,
          <Testimonial
            key={4}
            title="Sold before print advertising comes out"
            body="I would like to thank you for your amazing website. We were struggling to sell our truck and had booked advertising in a print magazine, but it wouldn't be out for weeks, so we decided to give Horsezone a try. We sold the truck within 2 days of posting the ad! The only problem now is when the print advertising finally comes out the truck will already be sold, which is why instant advertising online is so much better. We will definitely be advertising with Horsezone in the future. Thank you again!"
            author="Teale Drummond"
            memberState="NSW"
            memberSince="2013"
          />,
          <Testimonial
            key={5}
            title="Club Contribution and Integration waorks for our Club!"
            body="We are extremely happy with the Horsezone Club Contribution Scheme. Since integrating less than a year ago we have raised nearly $300 for sponsorship of our events."
            author="Jane Doe"
            memberState="NSW"
            memberSince="2020"
          />,
          <Testimonial
            key={6}
            title="Sold within days!"
            body="I was in the process of selling my reining/western allrounder gelding and hadn't had any luck with print advertising. I was busy with work and didn’t have a lot of spare time, when Jo Johnson contacted me and asked if I would like to advertise with Horsezone. It was only $30.00 for a basic ad and $60 for a featured ad, so I thought why not (I went with the featured ad option). Plus there was no time-limit on the advert once posted and I thought that was pretty good value. Because I was so busy Jo offered to write my advert and set up the ad with the photos and videos I had supplied. Once I had approved the ad and it went live, within 30 minutes I received a phone call. That was Friday, the horse was sold on Sunday! I said to my friends, “Anybody would have thought the horse was made of gold I got that many phone calls and emails from the Horsezone ad.” I was really happy with the service I received and would use Horsezone again to sell a horse."
            author="Helen Balu"
            memberState="QLD"
            memberSince="2013"
          />,
          <Testimonial
            key={7}
            title="Nothing worked until I came across Horsezone!"
            body="Just wanted to say a huge thank you to Horsezone for your help in selling my 2 ponies. I have had them advertised on other platforms for 3 months with next to no enquiries and no success in selling them. I received an email from you guys about your web site and thought it couldn't hurt to give it a go. Well, I was amazed! I have sold both my boys within 2 weeks of being advertised on your site!!! Thank you so much! Very happy with your web site and service and will definitely use Horsezone for all my advertising in the future!"
            author="Rachelle Corfield"
            memberState="NSW"
            memberSince="2013"
          />,
          <Testimonial
            key={8}
            title="Such a great experience!"
            body="Horse zone was a super easy website that made selling my horse an easy and stress free experience. I loved receiving email updates of how my advertisement was going. We were able to reach a huge audience at a reasonable price. Great experience and would Highly recommend the site to anyone looking to buy or sell!!"
            author="Jess O'Connor"
            memberState="NSW"
            memberSince="2013"
          />,
          <Testimonial
            key={9}
            title="So easy to use!"
            body="Your service is so easy to use and I have no improvements to suggest. Thank you!"
            author="Joan O'Reilly"
            memberState="VIC"
            memberSince="2012"
          />,
          <Testimonial
            key={10}
            title="Home Found"
            body="Hi Horsezone, I have found a home for my mare via your site. I would like to thank you for the great work you do. Best Regards."
            author="Linda Blandford"
            memberState="VIC"
            memberSince="2014"
          />,
          <Testimonial
            key={11}
            title="Very Happy!"
            body="Thanks for running such a great site. We have had instant success with all 3 horses I have listed in the last year, priced from $2500 through to $20000. It is affordable, easy to use and most importantly has really really great results!"
            author="Tracey Boyle"
            memberState="NSW"
            memberSince="2013"
          />,
          <Testimonial
            key={12}
            title="One Happy Customer!"
            body="Dear Horse Zone, Very very happy with the response I had with advertising with Horsezone. Within 3 days of advertising I had numerous enquiries and our boy was sold within the week. Very reasonable and realistic advertising prices too :) Thanking you! One Happy Customer."
            author="Sue Boor"
            memberState="QLD"
            memberSince="2013"
          />,
          <Testimonial
            key={13}
            title="I Highly Recommend Horsezone"
            body="Thankyou so much in assisting me with the sale of my thoroughbred! He went to a lovely home and sold within less than a month! You guys do a fantastic job and I highly recommend you to all my friends trying to sell horses!! Thankyou"
            author="Enja Prest"
            memberState="NSW"
            memberSince="2014"
          />,
          <Testimonial
            key={14}
            title="Thanks Horsezone!"
            body="I think Horsezone is WONDERFUL!! I found the best of homes for my lovely Warmblood mare and sold my second saddle through your site and just think you are the best! Then Horsezone AGAIN came through and I sold my young Gypsy Cob x Warmblood gelding to a perfect home in QLD. They contacted me after you made him ‘Horse of the Day’ on Facebook, so that may well have helped awareness, either way I’m so rapt with your service, thanks so much again."
            author="Anita Norris"
            memberState="VIC"
            memberSince="2013"
          />,
        ]}
      />
    </Box>
  );
}
